export const CRM_ACCESS_SOURCES = {
  SALESFORCE: 'salesforce',
  TIER: 'tier',
  BOTH: 'both',
}

const ENABLED_LABEL_KEYS = {
  [CRM_ACCESS_SOURCES.SALESFORCE]: 'crm-access-enabled-salesforce',
  [CRM_ACCESS_SOURCES.TIER]: 'crm-access-enabled-tier',
  [CRM_ACCESS_SOURCES.BOTH]: 'crm-access-enabled-both',
}

export const CRM_TIER_LABEL_KEYS = {
  limited: 'limited',
  advantage: 'advantage',
  pro: 'pro',
  freeTrial: 'free-trial',
  sapAdvantage: 'sap-advantage',
  appMax: 'app-max',
  procurementPro: 'procurement-pro',
  expired: 'expired',
}

export const getCrmAccessLabelKey = ({
  crmAccessEnabled,
  crmAccessSource,
} = {}) => {
  if (crmAccessEnabled !== true) return 'crm-access-disabled'
  return ENABLED_LABEL_KEYS[crmAccessSource] || 'crm-access-enabled'
}

export const getCrmTierLabelKey = tier => CRM_TIER_LABEL_KEYS[tier] || tier
